var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityDbMqtt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "db_mqtt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4c-0.228 0-0.449 0.030-0.666 0.067-1.18 0.199-2.175 0.912-2.763 1.904-0.354 0.597-0.57 1.285-0.57 2.029v16c0 2.209 1.791 4 4 4h16c0.744 0 1.432-0.217 2.029-0.57 0.992-0.588 1.705-1.583 1.904-2.763 0.037-0.218 0.067-0.438 0.067-0.666v-16c0-2.209-1.791-4-4-4zM8 26c-1.103 0-2-0.897-2-2v-5.899c4.155 0.467 7.431 3.744 7.899 7.899h-5.899zM15.95 26c-0.476-5.276-4.673-9.474-9.95-9.95v-4c7.473 0.496 13.453 6.477 13.949 13.949h-4zM24 26h-2.051c-0.501-8.588-7.362-15.448-15.949-15.949v-2.051c0-0.915 0.63-1.656 1.47-1.893 9.634 1.133 17.29 8.789 18.423 18.423-0.237 0.84-0.978 1.47-1.893 1.47zM26 17.531c-2.309-5.111-6.42-9.222-11.531-11.531h7.513c1.476 1.196 2.822 2.542 4.018 4.018v7.513z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityDbMqtt);
export default __webpack_public_path__ + "static/media/unity_db_mqtt.7ec72a2af5ac12aebc32f297704d3186.svg";
export { ForwardRef as ReactComponent };